import type { Ref } from "vue";

import { useRoute } from "#app/composables/router";
import { watch } from "vue";

declare module "vue-router" {
  // oxlint-disable-next-line consistent-type-definitions -- module augmentation requires interface
  interface RouteMeta {
    // LayoutDefault's bare variant: fixed per route, or the CMS toggle `general.focusPage`
    focusPage?: boolean;
  }
}

type FocusPageState = Ref<{
  data?: { general?: { focusPage?: boolean | null } | null };
  status: string;
}>;

/**
 * Client navigation without cached data: middleware/focusPageLayout.global.ts kept the current
 * variant, so set the page's own once its data is in. On this page's own route: app.vue reads
 * the displayed route, so the variant changes only once this page is on screen.
 */
function useFocusPageLayout(state: FocusPageState) {
  if (import.meta.server) {
    return;
  }
  const route = useRoute();

  watch(
    state,
    () => {
      if (state.value.status === "success") {
        route.meta.focusPage = state.value.data?.general?.focusPage ?? false;
      }
    },
    { immediate: true },
  );
}

export { useFocusPageLayout };
